import React, {Component} from 'react'
import StyleSheet from '../../styles'

export class FilterBar extends Component {
  render = () =>
    <div {...this.props} className={[styles.filterBar, this.props.className].filter(c => c).join(' ')} />
}

const styles = StyleSheet({
  filterBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '20px',
    '@media print': {
      display: 'none'
    },
    '@media(max-width: 420px)': {
      flexWrap: 'wrap',
      '& > :first-child': {
        width: '100%',
        marginRight: 0,
        marginBottom: 10,
      }
    }
  },
})